<template>
  <div>
    <header-bar>YouTubeマネタイズ</header-bar>
    <div>
      <div class="page-block">
        <div class="page-block__heading page-block__heading--withbar">
          <h3 class="page-block__title">アセット検索</h3>
        </div>
        <div class="page-block__inner">
          <assets-search
            :pre-search-keyword="keyword"
            @on-change-query="onSearchQueryChanged" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../../HeaderBar'
import YouTubeAssetsSearch from './Search'

export default {
  name: 'YouTubeAssetsIndex',
  components: {
    HeaderBar,
    AssetsSearch: YouTubeAssetsSearch,
  },
  data() {
    return {
      keyword: '',
    }
  },
  mounted() {
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword
    }
  },
  methods: {
    onSearchQueryChanged(query) {
      this.$router.push({
        name: this.$route.name,
        query,
      })
    },
  },
}
</script>
